import React, { useEffect } from 'react';

import { useHashRouteContext } from '../../../../../shared/components/hash-route';
import { logError } from '../../../../../shared/error/logError';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

import { removeHash } from '../../../../../shared/router/hash/hashHistory';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';

import { ParkingProductDetailsHeader } from './ParkingProductDetailsHeader';
import { ParkingProductDetailsMain } from './ParkingProductDetailsMain';

interface IParkingProductDetailsHashMatches {
	parkingProductId: string;
}

interface IParkingProductDetailsDailogProps {
	onSelectProduct: (parkingProduct: IParkingProduct) => void;
}

export const ParkingProductDetailsDialog = ({
	onSelectProduct,
}: IParkingProductDetailsDailogProps) => {
	const { t } = useTranslation();
	const { matches } = useHashRouteContext<IParkingProductDetailsHashMatches>();
	const { parkingProductsQuoteStore } = useNewBookingStore();

	const parkingProductId = parseInt(matches.parkingProductId, 10);
	const parkingProduct =
		parkingProductsQuoteStore.findParkingProduct(parkingProductId);

	useEffect(() => {
		// This should not happen...
		if (!parkingProductsQuoteStore.isLoading && !parkingProduct) {
			// ..so when it does happen, we log an error
			logError(new Error(`Parking product not found: ${parkingProductId}`));
			removeHash();
		}
	}, [parkingProductsQuoteStore, parkingProduct, parkingProductId]);

	// Fallback just in case
	if (!parkingProduct) {
		return <h1>Loading...</h1>;
	}

	const onSelectProductClick = () => {
		onSelectProduct(parkingProduct);
	};

	return (
		<>
			<ParkingProductDetailsHeader
				parkingProduct={parkingProduct}
				onSelectProductClick={onSelectProductClick}
				buttonLabel={t('parking_product_details_select_button_label')}
			/>
			<ParkingProductDetailsMain parkingProduct={parkingProduct} />
		</>
	);
};
